import { createFileRoute } from '@tanstack/react-router';

import { AdminV3AgentRoutePage } from '@apps/web/features/admin_v3_playground';

// A pathless layout for the chat routes only, so the conversation page stays
// mounted across the blank, new, and run-id routes without wrapping the other
// /admin/agent pages.
export const Route = createFileRoute('/_app/admin/agent/_chat')({
    head: () => ({ meta: [{ title: 'Internal Admin Agent' }] }),
    component: AdminV3AgentRoutePage,
});
